define([
	"dojo/_base/declare",
	"csi/heading/RefContainer"
], function(declare, RefContainer) {

	return declare(RefContainer, {
		/** @override - Allow custom options in react inline editing */
		reactAllowCustomOptions: true,

		/** @override - React inline editing component placeholder resource if not standard */
		reactPlaceholderRes: "SelectAddNew",

		// Boolean: allow copying of tags
		bCopy: true,

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: render editable control for attribute
			//Give option to add new Tag only if context Node Type is available. Otherwise, it will be available also in the CV dialog filter pane as well.
			if (ctx.getNodeType()) {
				params.addNewItem = true;
				params.defaultDisplayValue = "SelectAddNew";
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Use this renderer for formatting values rather than simple string renderer
		 */
		getQuerySpec: function(ctx, h, spec) {
			const qs = this.inherited(arguments);
			qs.ren = this;
			return qs;
		},

		/**
		 * @override
		 * Assign TagController to action
		 */
		_getRenderActionForHeading(ctx, h) {
			const a = this.inherited(arguments);
			a.classController = "csi/heading/TagController";
			return a;
		},

		/** 
		 * return true if react renderer exists for given attribute type and should be used
		 * @override
		 */
		useReactInlineDialog() {
			return false;
		},

	});
});